import React from 'react'
import { useLocation } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { Navigate } from "react-router-dom";
import { SEARCHPARAM } from '../components/ListTrackComponent';

export const RequireAuth = ({ children }) => {
    let { user } = useAuth();
    let location = useLocation();

    const querySearch = new URLSearchParams(location.search).get(SEARCHPARAM);
    if(querySearch){
      localStorage.setItem(SEARCHPARAM, querySearch);
    }

    if (!user || user === null) {  
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    else if(localStorage.getItem("user") === null || localStorage.getItem("user") === "null") {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
};